// extracted by mini-css-extract-plugin
module.exports = {"message":"StepRegisterContent_message__2Y2Ao","success":"StepRegisterContent_success__3ISUy StepRegisterContent_message__2Y2Ao"};